module.exports = __webpack_public_path__ + "img/cur6.34440330.png";